import ko from 'knockout';
import 'CommonScripts/WCCKOCustomBindings';

system.importAll(require.context('./constructors/', false, /\.[jt]s$/));
system.importAll(require.context('./functions/', false, /\.[jt]s$/));
system.importAll(require.context('./extenders/', false, /\.[jt]s$/));

export default ko;